
const historicalWorkOrder = {
    namespaced: true,
    state: {
        historical_workorder_form_data: {}
    },
    mutations: {
        SET_HISTORICAL_WORKORDER_FORM_DATA(state, data) {
            state.historical_workorder_form_data = data;
        },
    },
    actions: {

    },
    getters: {
        historical_workorder_form_data: state => state.historical_workorder_form_data
    }
};

export default historicalWorkOrder;
